export default "__VITE_ASSET__iYynb$Pi__"